import { render, staticRenderFns } from "./DashboardHero.vue?vue&type=template&id=5f46874a"
import script from "./DashboardHero.vue?vue&type=script&lang=js"
export * from "./DashboardHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports